export default function config() {
  // Table Handlers
  const tableColumns = [
    { key: 'index', label: '#' },
    { key: 'user', label: 'Applicant', sortable: true },
    { key: 'course', label: 'Course', sortable: true },
    { key: 'dc_type', label: 'Dc Type', sortable: true },
    { key: 'direction', label: 'Direction', sortable: true },
    { key: 'edu_lang', label: 'Education Language', sortable: true },
    { key: 'quarter', label: 'Quarter', sortable: true },
    { key: 'organization', label: 'Organization', sortable: true },
    { key: 'applied_time', label: 'Applied Time', sortable: true },
    { key: 'user.mob_phone_no', label: 'Phone', sortable: true },
    { key: 'monitoring', label: 'Monitoring', sortable: false },
    { key: 'certificate', label: 'Certificate', sortable: false },
    { key: 'status', label: 'Status', sortable: true },
    { key: 'actions', label: 'Actions' },
  ]

  return {
    tableColumns,
  }
}
